import { appstr } from "@coreapp/utils/appstr";
import { ColorTrigger, DialogContent, Flex, Text } from "@theorgchartdev/storybook";
import BrandStyleCanvasPreview from "@/appComponents/Blocks/Modals/BrandSetupModal/BrandStyleCanvasPreview";
import CompositeColorPicker from "@/appComponents/Blocks/Composites/CompositeColorPicker/CompositeColorPicker";
import { useRef } from "react";

export type BoxStyleDefaults = {
  brandingFill: string;
  brandingBorder: string;
};

type SetBrandColorsProps = {
  boxStyleDraft: BoxStyleDefaults;
  setBoxStyleDraft: (draft: BoxStyleDefaults) => void;
};

const SetBrandColors = ({ boxStyleDraft, setBoxStyleDraft }: SetBrandColorsProps) => {
  const fillColorOpenCtrlRef = useRef(null);
  const borderColorOpenCtrlRef = useRef(null);

  return (
    <DialogContent customContentClass="oc-brand-setup-content">
      <Flex direction="column" gap="8px">
        <Text size="large" modifier="medium">
          {appstr("Set brand colors")}
        </Text>
        <Text>
          {appstr(
            "Choose colors for your org chart boxes. They will be applied to all default system boxes and views. You can skip this step and edit later in the Box Layout Editor."
          )}
        </Text>
      </Flex>

      <Flex gap="24px">
        <Flex gap="8px">
          <Text size="small" modifier="medium">
            {appstr("Box fill color:")}
          </Text>
          <CompositeColorPicker
            openCtrlRef={fillColorOpenCtrlRef}
            trigger={<ColorTrigger iconName="fill-drip" size="small" />}
            currentColor={boxStyleDraft.brandingFill}
            onChange={(color: unknown) => {
              if (typeof color === "string") {
                setBoxStyleDraft({ ...boxStyleDraft, brandingFill: color });
              }
            }}
            showGradient={false}
            showNoFill={false}
          />
        </Flex>

        <Flex gap="8px">
          <Text size="small" modifier="medium">
            {appstr("Box border color:")}
          </Text>
          <CompositeColorPicker
            openCtrlRef={borderColorOpenCtrlRef}
            trigger={<ColorTrigger iconName="pen" size="small" />}
            currentColor={boxStyleDraft.brandingBorder}
            onChange={(color: unknown) => {
              if (typeof color === "string") {
                setBoxStyleDraft({ ...boxStyleDraft, brandingBorder: color });
              }
            }}
            showGradient={false}
            showNoFill={false}
          />
        </Flex>
      </Flex>

      <BrandStyleCanvasPreview
        fill={boxStyleDraft.brandingFill}
        border={boxStyleDraft.brandingBorder}
      />
    </DialogContent>
  );
};

export default SetBrandColors;
